import React from "react";

/**
 * プレビュードロワー内ナビゲーション用コンテキスト。
 *
 * 区画プレビュードロワー内で入金詳細などを開く際、別ドロワーを重ねる(2重ドロワー)のを避け、
 * 同じドロワー内でコンテンツを切り替えるための仕組み。
 * Provider が居ない(=全画面/単独表示)場合は各コンポーネントが従来どおり自前のドロワーを開く。
 */

export interface PaymentDetailNavArgs {
  paymentId: string;
  /** Payment は Unit(section) で partition されるため必須 */
  propertySectionId: string;
  propertyId?: string;
  propertyName?: string;
  unitName?: string;
  /** パンくず/文脈の起点 (例: "payments" | "income")。 */
  fromSource?: string;
  /** 更新成功時のコールバック (一覧再取得など)。 */
  onUpdated?: (paymentId: string) => void;
}

export interface PreviewDrawerNav {
  /** ドロワー内で入金詳細を開く(コンテンツ切替。戻るで元のビューへ)。 */
  openPaymentDetail: (args: PaymentDetailNavArgs) => void;
}

export const PreviewDrawerNavContext =
  React.createContext<PreviewDrawerNav | null>(null);

export const usePreviewDrawerNav = (): PreviewDrawerNav | null =>
  React.useContext(PreviewDrawerNavContext);
